import styled, { css } from 'styled-components';
var FONT_SIZE_PRICE = {
  main: 'ft32',
  list: 'ft16',
  small: 'ft14',
  medium: 'ft20'
};
var FONT_SIZE_OLDPRICE = {
  main: 'ft24',
  list: 'ft16',
  small: 'ft14',
  medium: 'ft14'
};
export var PriceWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__PriceWrapper",
  componentId: "sc-1q1c6zk-0"
})(["font-family:", ";line-height:", ";text-align:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.fontFamily.primary;
}, function (props) {
  return props.variant === 'small' ? '1.1' : null;
}, function (props) {
  return props.alignRight === true ? 'right' : 'left';
});
export var CurrentPrice = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__CurrentPrice",
  componentId: "sc-1q1c6zk-1"
})(["display:", ";font-size:", ";font-weight:", ";color:", ";white-space:nowrap;", " &:last-of-type{margin-right:0;}"], function (props) {
  return props.variant === 'main' || props.variant === 'medium' ? 'block' : 'inline-block';
}, function (_ref2) {
  var variant = _ref2.variant,
    theme = _ref2.theme;
  return theme.fonts.fontSize[FONT_SIZE_PRICE[variant]];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontWeight.medium;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.text.secondary;
}, function (_ref5) {
  var alignRight = _ref5.alignRight,
    variant = _ref5.variant,
    theme = _ref5.theme;
  return alignRight ? css(["margin-left:", ";"], theme.spacing.sp8) : css(["margin-right:", ";"], variant === 'main' ? null : theme.spacing.sp8);
});
var LINE_POS = {
  main: 'ft16',
  list: 'ft12',
  medium: '0.55rem',
  small: '0.55rem'
};
export var OldPrice = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__OldPrice",
  componentId: "sc-1q1c6zk-2"
})(["display:inline-block;font-weight:", ";font-size:", ";color:", ";position:relative;&:after{content:'';display:block;border-bottom:", " solid ", ";transform:translateY( -", " );}"], function (_ref6) {
  var theme = _ref6.theme,
    variant = _ref6.variant;
  return variant === 'medium' ? theme.fonts.fontWeight.normal : theme.fonts.fontWeight.medium;
}, function (_ref7) {
  var variant = _ref7.variant,
    theme = _ref7.theme;
  return theme.fonts.fontSize[FONT_SIZE_OLDPRICE[variant]];
}, function (_ref8) {
  var theme = _ref8.theme,
    variant = _ref8.variant;
  return variant === 'medium' ? theme.colors.text.midGray : theme.colors.text.darkGray;
}, function (props) {
  return props.variant === 'main' ? '2px' : '1px';
}, function (_ref9) {
  var theme = _ref9.theme,
    variant = _ref9.variant;
  return variant === 'medium' ? theme.colors.border.midGray : theme.colors.border.darkGray;
}, function (_ref10) {
  var theme = _ref10.theme,
    variant = _ref10.variant;
  return variant === 'small' || variant === 'medium' ? LINE_POS[variant] : theme.fonts.fontSize[LINE_POS[variant]];
});
export var Indicator = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__Indicator",
  componentId: "sc-1q1c6zk-3"
})(["display:", ";", " font-size:", ";white-space:nowrap;"], function (props) {
  return props.variant === 'list' ? 'inline-block' : 'block';
}, function (_ref11) {
  var alignRight = _ref11.alignRight,
    variant = _ref11.variant,
    theme = _ref11.theme;
  return alignRight ? null : css(["margin-right:", ";"], variant === 'main' || variant === 'medium' ? null : theme.spacing.sp8);
}, function (_ref12) {
  var theme = _ref12.theme,
    variant = _ref12.variant;
  return variant === 'medium' ? theme.fonts.fontSize.ft12 : theme.fonts.fontSize.ft14;
});
export var Cents = /*#__PURE__*/styled.span.withConfig({
  displayName: "style__Cents",
  componentId: "sc-1q1c6zk-4"
})(["font-size:", ";vertical-align:super;", " &{display:inline-block;transform:translateY(3px);}"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.fonts.fontSize.ft16;
}, OldPrice);
export var Lowercase = /*#__PURE__*/styled.span.withConfig({
  displayName: "style__Lowercase",
  componentId: "sc-1q1c6zk-5"
})(["text-transform:lowercase;"]);